import { render, staticRenderFns } from "./AttachURLModal.vue?vue&type=template&id=05767c1f&"
import script from "./AttachURLModal.vue?vue&type=script&lang=js&"
export * from "./AttachURLModal.vue?vue&type=script&lang=js&"
import style0 from "./AttachURLModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05767c1f')) {
      api.createRecord('05767c1f', component.options)
    } else {
      api.reload('05767c1f', component.options)
    }
    module.hot.accept("./AttachURLModal.vue?vue&type=template&id=05767c1f&", function () {
      api.rerender('05767c1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/feed/AttachURLModal.vue"
export default component.exports